module.exports = __webpack_public_path__ + "img/linkfollower.10fb2547.png";